import { useAutorizaceStore } from '@gov-nx/store/autorizace/store';

interface AuthorizationResetProps {
	onResetFlow: () => void;
}

export const useAuthorizationReset = ({
	onResetFlow,
}: AuthorizationResetProps) => {
	const clearAuthorization = useAutorizaceStore('clearAuthorization');
	const setIsFailureSheetVisible = useAutorizaceStore(
		'setIsFailureSheetVisible'
	);
	const setFailedSubmissionId = useAutorizaceStore('setFailedSubmissionId');
	const clearPendingAuthorizedChange = useAutorizaceStore(
		'clearPendingAuthorizedChange'
	);

	const reset = () => {
		clearAuthorization();
		clearPendingAuthorizedChange();
		setIsFailureSheetVisible(false);
		setFailedSubmissionId(undefined);
		onResetFlow();
	};

	return { reset };
};
